import { Map } from 'immutable';
import CommercialAgent from './scenes/CommercialAgent';
import Project from './scenes/Project';
import CommercialAgentDetails from './scenes/CommercialAgent/details';
import ProjectDetails from './scenes/Project/details';
import Issues from './scenes/Issues';
import IssueDetails from './scenes/Issues/details';
import IssueCreate from './scenes/Issues/create';

export default new Map({
    '/commercialAgent': {
        firstPage: true,
        must_logged: true,
        component: CommercialAgent,
        right: 'commercialAgentList',
        children: new Map({
            /** Home detail */
            '/detail/:commercialAgentId': {
                must_logged: true,
                component: CommercialAgentDetails,
                right: 'commercialAgentDetails'
            }
        })
    },
    '/project': {
        must_logged: true,
        component: Project,
        right: 'projectList',
        children: new Map({
            /** Projet detail */
            '/detail/:projectId': {
                must_logged: true,
                component: ProjectDetails,
                right: 'projectDetails'
            }
        })
    },
    '/issues': {
        must_logged: true,
        component: Issues,
        right: 'issuesList',
        children: new Map({
            '/:issueId/projects/:projectId/': {
                must_logged: true,
                component: IssueDetails,
                right: 'issueDetails'
            },
            '/create': {
                must_logged: true,
                component: IssueCreate,
                right: 'issueCreate'
            }
        })
    }
});



// WEBPACK FOOTER //
// ./environments/simulationenr/routes.js